import { Action, Reducer } from "redux";
import { BillingAddressState, BillingAddressTypes, BillingAddressActionTypes } from "./billingAddressTypes";

export const INITIAL_STATE: BillingAddressState = {
	billingAddress: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const billingAddressReducer: Reducer<BillingAddressState> = (
	state: BillingAddressState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as BillingAddressActionTypes;
	switch (actionTypes.type) {
		case BillingAddressTypes.GET_BILLING_ADDRESS:
			return {
				...state,
				billingAddress: { ...state.billingAddress, isLoading: true },
			};
		case BillingAddressTypes.SAVE_BILLING_ADDRESS:
			return {
				...state,
				billingAddress: {
					...state.billingAddress,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case BillingAddressTypes.RESET_REDUCER_BILLING_ADDRESS:
			return {
				...state,
				billingAddress: INITIAL_STATE.billingAddress,
			};
		default:
			return state;
	}
};

export default billingAddressReducer;
